import { Input } from '@heroui/react'
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import z from 'zod'
import { isValidIBAN } from 'ibantools'
import { useTranslate } from '@/hooks/useTranslate'

export const ibanSchema = z
  .object({
    iban: z.string().refine((iban) => isValidIBAN(iban.replace(/\s+/g, '')), {
      message: 'iban_iban_hint'
    })
  })
  .transform((data) => ({
    iban: data.iban.replace(/\s+/g, '')
  }))

export type IbanFormData = z.infer<typeof ibanSchema>

interface IbanFormProps {
  onSubmit: (data: IbanFormData) => void
}

export const IbanForm = ({ onSubmit }: IbanFormProps) => {
  const { translate } = useTranslate()

  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm<IbanFormData>({
    resolver: zodResolver(ibanSchema),
    mode: 'onBlur',
    defaultValues: { iban: '' }
  })

  return (
    <form id="bank-transfer-form" onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="iban"
        render={({ field: { onChange, value, onBlur } }) => (
          <Input
            id="iban"
            radius="sm"
            size="sm"
            label={translate('iban_introduce_iban')}
            variant="bordered"
            classNames={{
              inputWrapper: 'border-solid'
            }}
            onBlur={onBlur}
            value={value}
            onChange={(e) => {
              const formattedIban = e.target.value
                .toUpperCase()
                .replace(/\s/g, '')
                .replace(/[^A-Z0-9]/g, '')

              onChange(formattedIban.match(/.{1,4}/g)?.join(' ') ?? '')
            }}
            isInvalid={!!errors.iban}
            errorMessage={
              errors.iban?.message ? translate(errors.iban.message) : undefined
            }
          />
        )}
      />
    </form>
  )
}
